import { createStore, combineReducers } from 'redux'
import { keycloakReducer } from './features/keycloak.redux'
import formReducer from './features/form'
import dataStorageReducer from './features/dataStorage'

export const sessionStorageStateKey = 'appState'

const previousState = sessionStorage.getItem(sessionStorageStateKey)

export const cacheAppState = () => {
  sessionStorage.setItem(sessionStorageStateKey, JSON.stringify(store.getState()))
}

const store = createStore(
  combineReducers({
    form: formReducer,
    keycloak: keycloakReducer,
    dataStorage: dataStorageReducer,
  }),
  previousState ? JSON.parse(previousState) : undefined,
  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export { store }
